import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader, Button } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type Phone } from 'entities/Phone/model/Phone'
import { PhoneDropdownCard } from 'entities/Phone'
import { SearchTypesEnum } from 'widgets/SearchDropdown'
import { type SearchDropdownNumbersStore } from 'widgets/SearchDropdown/store/searchDropdownNumbersStore'
import { useSearchDropdownContext } from 'widgets/SearchDropdown/context/searchDropdownContext'
import styles from './styles.module.scss'

type NumbersSearchDropdownContentProps = {
  store: SearchDropdownNumbersStore
  onCloseMenu?: () => void
  onSelect?: (item: Phone) => void
}

export const NumbersDropdownContentSearch: FC<NumbersSearchDropdownContentProps> = observer(
  ({ onCloseMenu, store, onSelect }) => {
    const { setIsShowMore, selectType, search, actionSearch, hasNumbersType } =
      useSearchDropdownContext()
    const { selectTypeItem, options } = store

    const handleSelectNumber = (item: Phone) => {
      actionSearch({
        value: '',
        exclude: 'numbers',
      })
      options?.handleSearch?.('')

      if (!hasNumbersType) selectType(SearchTypesEnum.numbers)

      selectTypeItem(item)
      onSelect?.(item)
      onCloseMenu?.()
    }

    const handleShowAll = () => {
      actionSearch({
        value: '',
        exclude: 'numbers',
      })
      options?.handleSearch?.('')
      selectType(SearchTypesEnum.numbers)
      setIsShowMore(true)
    }

    return (
      <div className={styles.wrap} aria-label={getAriaLabel('searchNumbersSelector')}>
        <p
          className={styles.searchTitle}
          aria-label={getAriaLabel('searchNumbersHeaderSelector')}
        >{`Numbers (${store.total})`}</p>
        {store.loading && (
          <div className={styles.spinner}>
            <SpinnerLoader ariaLabel={'NumbersDropdownContentSearch'} size={24} />
          </div>
        )}
        {!store.loading && store.hasItems && (
          <div className={styles.items}>
            {store.first3Items.map((item) => (
              <PhoneDropdownCard
                key={item.id}
                item={item}
                highlighter={search}
                onChange={handleSelectNumber}
                ariaLabel='searchNumberItem'
              />
            ))}
          </div>
        )}
        {!store.loading && !store.hasItems && (
          <div className={styles.notFound}>No results found</div>
        )}
        {!hasNumbersType && store.hasItems && (
          <div className={styles.showAll}>
            <Button
              disabled={store.loading}
              typeBtn={'informative'}
              text={'Show all'}
              onClick={handleShowAll}
            />
          </div>
        )}
      </div>
    )
  }
)
